import React from "react"
import {useWatch} from "react-hook-form"

import {HRadio} from "@components/headlessui/HRadio"
import QuestionSelect from "@modules/question/components/QuestionSelect"
import {IQuestion, QuestionField} from "@backend/types"

import {gameModeOptions} from "../../constants"


type GameModeProps = {
    parentField?: string,
    field: string,
    rules?: any,
    register: any,
    errors?: any,
    control?: any,
    setValue?:any,
    defaultValue?: string,
    questionFields?: QuestionField[],
    questionRefIdField?: string,
    questions?: IQuestion[],
    onSelect: (field: string, value: string) => void,
    onSelectedChange: (any) => void
}

export function GameMode(props: GameModeProps) {
    const {
        parentField,
        field,
        register,
        rules,
        errors,
        setValue,
        questionFields,
        questionRefIdField,
        questions,
        control,
        onSelect,
        onSelectedChange
    } = props

    const watch = useWatch({
        name: parentField ? `${parentField}.${props.field}` : props.field,
        control
    })

    return <>
        <div className="col-span-full">
            <HRadio
                register={register}
                parentField={parentField}
                field={field}
                rules={field}
                layout="horizontal"
                value={watch}
                setValue={onSelect}
                options={Object.values(gameModeOptions)}
            />
        </div>
        <div className="col-span-full">
            <QuestionSelect
                key={watch}
                register={register}
                errors={errors}
                questions={questions}
                questionFields={questionFields}
                questionRefIdField={questionRefIdField}
                control={control}
                setValue={setValue}
                options={gameModeOptions[watch].options || gameModeOptions[watch].optionsFn()}
                onQuestionsChange={onSelectedChange}
            />

        </div>
    </>
}